module.exports = "/_next/static/images/tg-50f9070b637c65a1554fce4bbb379cc4.svg";